import React, { useMemo, useEffect, useCallback } from 'react';
import { Spinner } from '../../../../common';
import MenuForm from './MenuForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { SortAscendingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useGetMenuItemQuery,
  useSaveMenuMutation,
} from '../../../../../redux/services/menu';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { useGetTeachersQuery } from '../../../../../redux/services/users';
import { useGetArticlesQuery } from '../../../../../redux/services/articles.jsx';
import { isUndefined } from 'lodash';

const MenuEdit = ({ mode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const isCreate = mode === 'create';
  const pageTitle = isCreate
    ? t('Pridanie položky menu')
    : t('Úprava položky menu');

  useEffect(() => {
    document.title = pageTitle + ' - FRI CMS';
  }, [pageTitle]); // Runs on mount

  const { saveSuccess } = useToastMessages();

  const { data: teachers, isLoading: isLoadingTeachers } =
    useGetTeachersQuery();
  const { data: articles, isLoading: isLoadingArticles } =
    useGetArticlesQuery();
  const { data: menuItemDetail, isLoading } = useGetMenuItemQuery(id, {
    skip: isUndefined(id),
  });

  const [saveMenuItem, { isSuccess: isSaveSuccess }] = useSaveMenuMutation();

  const teachersForSelect = useMemo(() => {
    return (
      teachers
        ?.map((teacher) => ({
          label: teacher.fullName,
          value: teacher.person_id,
          last_name: teacher.last_name ?? '',
          first_name: teacher.first_name ?? '',
        }))
        .sort(
          (a, b) =>
            a.last_name.localeCompare(b.last_name) ||
            a.first_name.localeCompare(b.first_name),
        ) ?? []
    );
  }, [teachers]);

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsMenu);
    }
  }, [isSaveSuccess]);

  const handleSave = useCallback(
    (values, id) => {
      saveMenuItem({ body: values, id });
    },
    [saveMenuItem],
  );

  if (isLoading || isLoadingTeachers || isLoadingArticles) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsMenu}
        backUrlTooltip={t('Tabuľka menu')}
        mainActions={[
          {
            onClick: () => navigate(routes.cmsMenuOrder),
            title: t('Zoradiť položky menu'),
            icon: <SortAscendingOutlined />,
          },
        ]}
        permissionsBasic="menu"
      />

      <MenuForm
        users={teachersForSelect}
        articlesCollection={articles ?? []}
        onSave={handleSave}
        itemId={id}
        menuItemDetail={menuItemDetail}
      />
    </>
  );
};

export default MenuEdit;
